/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { BRAND_CEL, BRAND_RCI } from 'contexts/CruiseSearchContext/constants';
import { SERVER_TOGGLES } from 'lib/constants';
import { BrandCode } from 'types';
import { MARKETING_SCRIPT_ID } from '../../../../globalization/Scripts/constants';

const ENVIRONMENTS = {
	dev: 'dev',
	tst: 'tst',
	stg: 'stg',
	prd: 'prd',
};
const MARKETS = {
	usa: 'usa',
	int: 'int',
	aus: 'aus',
	gbr: 'gbr',
	sgp: 'sgp',
	lac: 'lac',
	mex: 'mex',
	hkg: 'hkg',
	bhs: 'bhs',
	deu: 'deu',
	swe: 'swe',
	nor: 'nor',
	ita: 'ita',
	esp: 'esp',
	fra: 'fra',
	bra: 'bra',
};

function getDomainId(brand, environment) {
	const domainIds =
		environment !== ENVIRONMENTS.prd
			? {
					[BrandCode.RoyalCaribbean]: '9553c29f-dac9-4391-93be-d8cec16c6054-test',
					[BrandCode.Celebrity]: '3319fdd0-7269-4429-9be7-99ddc16b7a0a-test',
				}
			: {
					[BrandCode.RoyalCaribbean]: '9553c29f-dac9-4391-93be-d8cec16c6054',
					[BrandCode.Celebrity]: '3319fdd0-7269-4429-9be7-99ddc16b7a0a',
				};

	return domainIds[brand];
}

const getAppDynamicsScript = (scripts) => {
	return {
		id: MARKETING_SCRIPT_ID.appDynamics,
		src: scripts.appDynamics,
		strategy: 'afterInteractive',
	};
};

const getAppDynamicsInlineScript = (brand, appDynamicsAppKey) => {
	const inline = {
		C: `
      window['adrum-start-time'] = new Date().getTime();
      (function (config) {
        config.appKey = '${appDynamicsAppKey}';
        config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
        config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
        config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
        config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
        config.useHTTPSAlways = true;
        config.resTiming = {'bufSize':300,'clearResTimingOnBeaconSend':true};
        config.xd = {enable: true};
        config.maxUrlLength = 2048;
        config.enableCoreWebVitals = true;
        config.spa = {'spa2':{'clearResTiming':true}};
        config.navComplete = {
          maxResourceQuietTime: 500,
          maxXhrQuietTime: 500,
          maxInactiveTime: 500,
        };
        function getCookieValue(cookieName) {
          try {
            var value = "; " + document.cookie;
            var parts = value.split("; " + cookieName + "=");
            if (parts.length == 2) {
              return parts
                .pop()
                .split(";")
                .shift();
            } else {
              return "";
            }
          } catch (err) {
            return "error";
          }
        }
        config.userEventInfo = {
          PageView: function (context) {
            return {
              userDataDouble: {
                bookingAmount: parseFloat(getCookieValue("Persist_Room_Price"))
              },
              userData: {
                BlueGreenValue: getCookieValue("bgv"),
                MarketingCloudID: getCookieValue("MCMID"),
                LoyaltyID: getCookieValue("Persist_Loyalty_ID"),
                bookingCurrency: getCookieValue("Persist_Currency_Code"),
                destinationCode: getCookieValue("Persist_Dest_Code"),
                productName: getCookieValue("Persist_Product_Name"),
                bookingId: getCookieValue("bookingId"),
                sessionID: getCookieValue("sessionID"),
                authToken: getCookieValue("authToken"),
                videoTest: getCookieValue("ab-test-qa"),
                WUC: getCookieValue("wuc"),
                country: getCookieValue("country"),
                currency: getCookieValue("currencyCode"),
                autSession: getCookieValue("autsession"),
                AEM_Modernization:"true"
              }
            };
          },
          Ajax: function (context) {
            return {
              userDataDouble: {
                bookingAmount: parseFloat(getCookieValue("Persist_Room_Price"))
              },
              userData: {
                BlueGreenValue: getCookieValue("bgv"),
                MarketingCloudID: getCookieValue("MCMID"),
                LoyaltyID: getCookieValue("Persist_Loyalty_ID"),
                bookingCurrency: getCookieValue("Persist_Currency_Code"),
                destinationCode: getCookieValue("Persist_Dest_Code"),
                productName: getCookieValue("Persist_Product_Name"),
                bookingId: getCookieValue("bookingId"),
                sessionID: getCookieValue("sessionID"),
                authToken: getCookieValue("authToken"),
                videoTest: getCookieValue("ab-test-qa"),
                WUC: getCookieValue("wuc"),
                country: getCookieValue("country"),
                currency: getCookieValue("currencyCode"),
                autSession: getCookieValue("autsession"),
                AEM_Modernization:"true"
              }
            };
          },
          VPageView: function (context) {
            return {
              userDataDouble: {
                bookingAmount: parseFloat(getCookieValue("Persist_Room_Price"))
              },
              userData: {
                BlueGreenValue: getCookieValue("bgv"),
                MarketingCloudID: getCookieValue("MCMID"),
                LoyaltyID: getCookieValue("Persist_Loyalty_ID"),
                bookingCurrency: getCookieValue("Persist_Currency_Code"),
                destinationCode: getCookieValue("Persist_Dest_Code"),
                productName: getCookieValue("Persist_Product_Name"),
                bookingId: getCookieValue("bookingId"),
                sessionID: getCookieValue("sessionID"),
                authToken: getCookieValue("authToken"),
                videoTest: getCookieValue("ab-test-qa"),
                WUC: getCookieValue("wuc"),
                country: getCookieValue("country"),
                currency: getCookieValue("currencyCode"),
                autSession: getCookieValue("autsession"),
                AEM_Modernization:"true"
              }
            };
          }
        };
      })(window["adrum-config"] || (window["adrum-config"] = {}));
    `,
		R: `
      window['adrum-start-time'] = new Date().getTime();
      (function (config) {
        config.appKey = '${appDynamicsAppKey}';
        config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
        config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
        config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
        config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
        config.useHTTPSAlways = true;
        config.resTiming = {'bufSize':300,'clearResTimingOnBeaconSend':true};
        config.xd = {enable: true};
        config.maxUrlLength = 2048;
        config.enableCoreWebVitals = true;
        config.spa = {'spa2':{'clearResTiming':true}};
        config.navComplete = {
          maxResourceQuietTime: 500,
          maxXhrQuietTime: 500,
          maxInactiveTime: 500,
        };

        var pageName = '';
        //set error page names
        switch (window.document.title) {
          case 'Page Not Found | Royal Caribbean Cruises':
            pageName = '404 Error Page';
            break;
          case 'Server Error | Royal Caribbean Cruises':
            pageName = '5xx Error Page';
            break;
        }

        function getCookieValue(cookieName) {
          try {
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + cookieName + '=');
            if (parts.length == 2) {
              return parts.pop().split(';').shift();
            } else {
              return '';
            }
          } catch (err) {
            return 'error';
          }
        }

        //send data to appd
        config.userEventInfo = {
          PageView: function (context) {
            return {
              userPageName: pageName,
              userData: {
                BlueGreenValue: getCookieValue('bgv'),
                MarketingCloudID: getCookieValue('MCMID'),
                LoyaltyID: getCookieValue('loyalty_ID'),
                JSession: getCookieValue('jsess'),
                BookingID: getCookieValue('booking_ID'),
                WUC: getCookieValue('wuc'),
                country: getCookieValue('country'),
                currency: getCookieValue('currency'),
                autSession: getCookieValue('autsession'),
              },
              userDataLong: {
                cookieSize: encodeURIComponent('<q></q>' + document.cookie).length,
              },
            };
          },
          Ajax: function (context) {
            return {
              userData: {
                BlueGreenValue: getCookieValue('bgv'),
                MarketingCloudID: getCookieValue('MCMID'),
                LoyaltyID: getCookieValue('loyalty_ID'),
                JSession: getCookieValue('jsess'),
                BookingID: getCookieValue('booking_ID'),
                WUC: getCookieValue('wuc'),
                country: getCookieValue('country'),
                currency: getCookieValue('currency'),
                autSession: getCookieValue('autsession'),
              },
              userDataLong: {
                cookieSize: encodeURIComponent('<q></q>' + document.cookie).length,
              },
            };
          },
          VPageView: function (context) {
            return {
              userData: {
                BlueGreenValue: getCookieValue('bgv'),
                MarketingCloudID: getCookieValue('MCMID'),
                LoyaltyID: getCookieValue('loyalty_ID'),
                JSession: getCookieValue('jsess'),
                BookingID: getCookieValue('booking_ID'),
                WUC: getCookieValue('wuc'),
                country: getCookieValue('country'),
                currency: getCookieValue('currency'),
                autSession: getCookieValue('autsession'),
              },
              userDataLong: {
                cookieSize: encodeURIComponent('<q></q>' + document.cookie).length,
              },
            };
          },
        };
      })(window['adrum-config'] || (window['adrum-config'] = {}));
    `,
	};

	return {
		id: MARKETING_SCRIPT_ID.appDynamicsInline,
		inline: inline[brand],
		strategy: 'afterInteractive',
	};
};

const getCookieLawScript = (brand, env, oneTrustScriptStrategy) => {
	const domainId = getDomainId(brand, env);
	return {
		id: MARKETING_SCRIPT_ID.cookieLaw,
		src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
		strategy: oneTrustScriptStrategy,
		dataAttributes: [
			{
				key: 'document-language',
				value: 'true',
			},
			{
				key: 'domain-script',
				value: domainId,
			},
			{
				key: 'charset',
				value: 'UTF-8',
			},
		],
	};
};

const getMedalliaScript = () => {
	return {
		id: MARKETING_SCRIPT_ID.medallia,
		inline: `
      if (window.KAMPYLE_ONSITE_SDK && typeof window.KAMPYLE_ONSITE_SDK.updatePageView === 'function'){
        window.KAMPYLE_ONSITE_SDK.updatePageView();
      }
    `,
		strategy: 'afterInteractive',
		toggle: SERVER_TOGGLES.ENABLE_MEDALLIA_EMBEDDED_SURVEY,
	};
};

const getOneSignalScript = () => {
	return {
		id: MARKETING_SCRIPT_ID.oneSignal,
		src: '//cdn.onesignal.com/sdks/OneSignalSDK.js',
		strategy: 'afterInteractive',
	};
};

const getOneTrustBannerScript = (brand, oneTrustScriptStrategy) => {
	const scripts = {
		[BrandCode.Celebrity]: [
			{
				id: MARKETING_SCRIPT_ID.oneTrustBanner,
				inline: 'function OptanonWrapper() {}',
				strategy: oneTrustScriptStrategy,
			},
		],
		[BrandCode.RoyalCaribbean]: {
			id: MARKETING_SCRIPT_ID.oneTrustBanner,
			inline: `
        var oneTrustBannerDisplay= 0;
        function OptanonWrapper() {  
          if(oneTrustBannerDisplay=== 1){
              utag.link({oneTrustBanner : true}); 
              window.utag.view(utag_data);
          }
          oneTrustBannerDisplay= oneTrustBannerDisplay+1;
        }
      `,
			strategy: oneTrustScriptStrategy,
		},
	};
	return scripts[brand];
};

const getOptimizely = () => {
	return {
		id: MARKETING_SCRIPT_ID.optimizely,
		inline: `
      function loadScriptAsync(url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.onload = callback;
        document.getElementsByTagName("head")[0].appendChild(script);
      };
      loadScriptAsync(window.env.API.optimizelyTag, function() {
        loadScriptAsync("//unpkg.com/@optimizely/optimizely-sdk/dist/optimizely.browser.umd.min.js", function() {
          if (optimizelySdk) {
              optimizelyClientInstance = optimizelySdk.createInstance({
                datafile: window.optimizelyDatafile,
              });
              optimizelySdk.setLogLevel('error');
            }
        });
      });
    `,
		strategy: 'afterInteractive',
	};
};

const getTealiumSyncScript = (profile) => {
	return {
		id: MARKETING_SCRIPT_ID.tealium,
		src: `https://tags.tiqcdn.com/utag/rccl/${profile}/utag.sync.js`,
		strategy: 'beforeInteractive',
	};
};

const getTealiumInlineScript = (profile, tealiumPosition) => {
	return {
		id: MARKETING_SCRIPT_ID.tealiumInline,
		inline: `
      var utag_data = {};
      window.utag_cfg_ovrd = {noview : true};
      (function(a,b,c,d) {
        a='https://tags.tiqcdn.com/utag/rccl/${profile}/utag.js';
        b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
        a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
        if(window?.location?.pathname?.includes('/compare')) {
          d.onload = function () {
            utag.view({});
          };
        }
      })();
    `,
		strategy: tealiumPosition,
	};
};

const getBazaarVoice = (settingsBazaar) => {
	const { env, brand } = settingsBazaar;
	return {
		id: MARKETING_SCRIPT_ID.bazaarVoice,
		src: `https://apps.bazaarvoice.com/deployments/${brand}/main_site/${env}/en_US/bv.js`,
		strategy: 'afterInteractive',
	};
};

export const getBazaarVoiceSetting = (config) => {
	const { brand, env } = config;
	const bazaarVoiceSettings = [
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			settingsBazaar: {
				env: 'staging',
				brand: BRAND_RCI.bazaarVoicePath,
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			settingsBazaar: {
				env: 'production',
				brand: BRAND_RCI.bazaarVoicePath,
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_CEL.code,
			settingsBazaar: {
				env: 'staging',
				brand: BRAND_CEL.bazaarVoicePath,
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_CEL.code,
			settingsBazaar: {
				env: 'production',
				brand: BRAND_CEL.bazaarVoicePath,
			},
		},
	];
	return bazaarVoiceSettings.find((item) => item.brand === brand.code && item.environments.includes(env)) || bazaarVoiceSettings[0];
};

export const getMarketingScriptsSettings = (market, config) => {
	const { brand, env, publicKeys } = config;
	const marketingScriptsSettings = [
		// RCI
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.usa, MARKETS.bhs],
			settings: {
				tealiumProfile: 'gdp/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.int],
			settings: {
				tealiumProfile: 'gdp-rcl-intl-eng/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.aus],
			settings: {
				tealiumProfile: 'gdp-rcl-australia/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.gbr],
			settings: {
				tealiumProfile: 'gdp-rcl-uk/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.sgp],
			settings: {
				tealiumProfile: 'gdp-rcl-singapore/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.lac],
			settings: {
				tealiumProfile: 'gdp-rcl-lacar/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.mex],
			settings: {
				tealiumProfile: 'gdp-rcl-mexico/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.hkg],
			settings: {
				tealiumProfile: 'gdp-rcl-hongkong/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.deu],
			settings: {
				tealiumProfile: 'gdp-rcl-germany/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.swe],
			settings: {
				tealiumProfile: 'gdp/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.nor],
			settings: {
				tealiumProfile: 'gdp/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.ita],
			settings: {
				tealiumProfile: 'gdp-rcl-italy/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.esp],
			settings: {
				tealiumProfile: 'gdp-rcl-spain/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.fra],
			settings: {
				tealiumProfile: 'gdp-rcl-france/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst, ENVIRONMENTS.stg],
			brand: BRAND_RCI.code,
			markets: [MARKETS.bra],
			settings: {
				tealiumProfile: 'gdp-rcl-brazil/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.usa, MARKETS.bhs],
			settings: {
				tealiumProfile: 'gdp/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.int],
			settings: {
				tealiumProfile: 'gdp-rcl-intl-eng/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.aus],
			settings: {
				tealiumProfile: 'gdp-rcl-australia/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.gbr],
			settings: {
				tealiumProfile: 'gdp-rcl-uk/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.sgp],
			settings: {
				tealiumProfile: 'gdp-rcl-singapore/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.lac],
			settings: {
				tealiumProfile: 'gdp-rcl-lacar/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.mex],
			settings: {
				tealiumProfile: 'gdp-rcl-mexico/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.hkg],
			settings: {
				tealiumProfile: 'gdp-rcl-hongkong/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.deu],
			settings: {
				tealiumProfile: 'gdp-rcl-germany/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.swe],
			settings: {
				tealiumProfile: 'gdp/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.nor],
			settings: {
				tealiumProfile: 'gdp/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.ita],
			settings: {
				tealiumProfile: 'gdp-rcl-italy/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.esp],
			settings: {
				tealiumProfile: 'gdp-rcl-spain/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.fra],
			settings: {
				tealiumProfile: 'gdp-rcl-france/prod',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_RCI.code,
			markets: [MARKETS.bra],
			settings: {
				tealiumProfile: 'gdp-rcl-brazil/prod',
			},
		},
		// CEL
		{
			environments: [ENVIRONMENTS.dev, ENVIRONMENTS.tst],
			brand: BRAND_CEL.code,
			markets: [],
			settings: {
				tealiumProfile: 'aem-celebrity/dev',
			},
		},
		{
			environments: [ENVIRONMENTS.stg],
			brand: BRAND_CEL.code,
			markets: [],
			settings: {
				tealiumProfile: 'aem-celebrity/qa',
			},
		},
		{
			environments: [ENVIRONMENTS.prd],
			brand: BRAND_CEL.code,
			markets: [],
			settings: {
				tealiumProfile: 'aem-celebrity/prod',
			},
		},
	];
	const foundSettings = marketingScriptsSettings.find(
		(s) => s.brand === brand.code && brandHasMarket(market, brand.code, s) && s.environments.includes(env),
	);
	const settings = foundSettings || marketingScriptsSettings[0];
	settings.settings.appDynamicsAppKey = publicKeys.appDynamicsAppKey;

	return settings;
};

const brandHasMarket = (market, brandCode, setting) => {
	if (brandCode === BrandCode.Celebrity) {
		return true;
	}

	return setting.markets.some((item) => item.toLowerCase() === market.toLowerCase());
};

const getBrandScripts = (brandSettings, config, options) => {
	const { tealiumPosition, oneTrustScriptStrategy } = options || {};
	// const { scripts, env } = config;
	const { env } = config;
	const { brand, settings, settingsBazaar } = brandSettings;
	// const { appDynamicsAppKey, tealiumProfile } = settings;
	const { tealiumProfile } = settings;
	const brandScripts = {
		[BRAND_CEL.code]: [
			getCookieLawScript(brand, env, oneTrustScriptStrategy),
			getOneTrustBannerScript(brand, oneTrustScriptStrategy),
			getTealiumInlineScript(tealiumProfile, tealiumPosition),
			getTealiumSyncScript(tealiumProfile),
			// getAppDynamicsInlineScript(brand, appDynamicsAppKey),
			// getAppDynamicsScript(scripts),
			getOneSignalScript(),
			getOptimizely(),
			getBazaarVoice(settingsBazaar),
		],
		[BRAND_RCI.code]: [
			getOneTrustBannerScript(brand, oneTrustScriptStrategy),
			getCookieLawScript(brand, env, oneTrustScriptStrategy),
			getTealiumInlineScript(tealiumProfile, tealiumPosition),
			// getAppDynamicsInlineScript(brand, appDynamicsAppKey),
			// getAppDynamicsScript(scripts),
			getMedalliaScript(),
			getBazaarVoice(settingsBazaar),
		],
	};

	return brandScripts[brand].flat();
};

export const getMarketingScripts = (market, config, options) => {
	if (market && config) {
		const { settings, brand } = getMarketingScriptsSettings(market, config);
		const { settingsBazaar } = getBazaarVoiceSetting(config);
		const scripts = getBrandScripts({ settings, brand, settingsBazaar }, config, options);

		return scripts;
	}

	return null;
};
